import React from 'react';
import { cx } from './cx';

interface CardProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  /** Body without padding, for tables that run edge to edge. */
  flush?: boolean;
}

const Card: React.FC<CardProps> = ({ title, subtitle, actions, flush, className, children, ...rest }) => (
  <section className={cx('ds-card', flush && 'ds-card--flush', className)} {...rest}>
    {(title || actions) && (
      <div className="ds-card__header">
        <div>
          {title && <h2 className="ds-card__title">{title}</h2>}
          {subtitle && <p className="ds-card__subtitle">{subtitle}</p>}
        </div>
        {actions}
      </div>
    )}
    <div className="ds-card__body">{children}</div>
  </section>
);

export default Card;
